import React from 'react';

import { HStack, Link } from '@betterment/samba-react';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { HouseholdQuery } from './HouseholdSummary/graphql/query.household.generated';
import { ImpersonationButton } from './ImpersonationButton';

import urlBuilder from '../../Shared/url-builder';

type Household = Extract<HouseholdQuery['household'], { __typename: 'Household' }>;
type Client = Household['members'][number];

export const HouseholdCta: React.FC<{
  members: Client[];
  showImpersonationModal: boolean;
  accountCreationAllowed: boolean;
}> = ({ members, showImpersonationModal, accountCreationAllowed }) => {
  const householdId = useRequiredParam('householdId');

  return (
    <HStack css={{ gap: 'space.200' }}>
      {accountCreationAllowed && (
        <Link href={urlBuilder.getAddAccountPage.absolute({ householdId })} variant="solidPrimary">
          Add account
        </Link>
      )}
      <Link href={urlBuilder.getStartTransferPage.absolute({ householdId })} variant="solidSecondary">
        Start a transfer
      </Link>
      <ImpersonationButton members={members} showImpersonationModal={showImpersonationModal} />
    </HStack>
  );
};
